import BroadcastsPage from "./broadcasts_page";
import { LayoutAdminCafe } from "../../../layout/layout_cafe";

export function AdminBroadcasts() {
  return (
    <LayoutAdminCafe>
      <BroadcastsPage />
    </LayoutAdminCafe>
  );
}
